import { Form, Formik } from 'formik';
import { GenericLoading } from 'components/ui/Loader';
import { ValidationTracker } from 'components/domain/ValidationTracker/ValidationTracker';
import { SpecialConditionsLayout } from './BorrowerSpecialConditionsLayout';
import { useSpecialConditionsForm } from './useSpecialConditionsForm';
import { BorrowerQuoteTabDto } from 'api/quote';

interface SpecialConditionsFormProps {
  quoteId: string;
  borrowerProjectId: string;
  insuranceProjectId?: string;
  personId?: string;
  quoteTabs?: BorrowerQuoteTabDto[] | null;
  risqueAssureId?: string;
  onSuccess?: () => void;
}

export const SpecialConditionsForm: React.FC<SpecialConditionsFormProps> = ({
  quoteId,
  borrowerProjectId,
  personId,
  quoteTabs,
  risqueAssureId,
  onSuccess
}) => {
  const {
    formikRef,
    initialValues,
    validationSchema,
    insuranceProjectCode,
    selectedInsuranceProjectCode,
    setSelectedInsuranceProjectCode,
    isLoading,
    isSubmitting,
    isFormValid,
    setIsFormValid,
    onSubmit
  } = useSpecialConditionsForm({
    quoteId,
    borrowerProjectId,
    onSuccess
  });

  if (isLoading) {
    return <GenericLoading isPageCentered loading />;
  }

  return (
    <div className="relative">
      {isSubmitting && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/60 rounded-lg">
          <GenericLoading loading />
        </div>
      )}
      <Formik
        enableReinitialize
        validateOnMount
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        innerRef={formikRef}
      >
        {({ isValid }) => (
          <>
            <ValidationTracker
              isValid={isValid}
              onValidationChange={setIsFormValid}
            />
            <Form>
              <SpecialConditionsLayout
                insuranceProjectCode={insuranceProjectCode}
                selectedInsuranceProjectCode={selectedInsuranceProjectCode}
                onInsuranceProjectCodeChange={setSelectedInsuranceProjectCode}
                personId={personId}
                quoteId={quoteId}
                quoteTabs={quoteTabs}
                risqueAssureId={risqueAssureId}
              />
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
};
